import { useState, useCallback } from "react";

export function useFirstVisitAnimation(isFirstVisit: boolean) {
    const [animationDone, setAnimationDone] = useState(false);

    const getDelay = (index: number) =>
        isFirstVisit && !animationDone ? `${index * 0.1}s` : undefined;

    const onAnimationEnd = useCallback(() => {
        setAnimationDone(true);
    }, []);

    return { animationDone, getDelay, onAnimationEnd };
}
